import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import Header from './Header';

function Callback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    // Handle OAuth errors from Cognito/Identity Center
    if (error) {
      let userMessage = 'Authentication failed. Please try again.';
      
      if (error === 'access_denied') {
        userMessage = 'Access denied: You must be a member of the Chat group to access this application.';
      } else if (error === 'invalid_grant') {
        userMessage = 'Authentication session expired. Please try logging in again.';
      } else if (error === 'invalid_request') {
        userMessage = 'Invalid authentication request. Please contact your administrator.';
      } else if (errorDescription) {
        // Use the error description if available
        if (errorDescription.toLowerCase().includes('not authorized')) {
          userMessage = 'Access denied: You must be a member of the Chat group to access this application.';
        } else if (errorDescription.toLowerCase().includes('password')) {
          userMessage = 'Authentication failed: Invalid username or password.';
        } else {
          userMessage = `Authentication error: ${errorDescription}`;
        }
      }
      
      setError(userMessage);
      return;
    }

    if (code) {
      authService.handleCallback(code)
        .then(() => navigate('/chat'))
        .catch(err => {
          console.error('Auth error:', err);
          let userMessage = 'An error occurred during authentication.';
          
          // Handle specific error messages
          if (err.message.includes('Token exchange failed')) {
            userMessage = 'Failed to complete authentication. Please try logging in again.';
          } else if (err.message.includes('Code verifier not found')) {
            userMessage = 'Authentication session lost. Please try logging in again.';
          } else if (err.message.includes('not authorized') || err.message.includes('Chat group')) {
            userMessage = 'Access denied: You must be a member of the Chat group to access this application.';
          } else if (err.message.includes('Network') || err.message.includes('fetch')) {
            userMessage = 'Network error: Unable to connect to authentication service. Please check your connection and try again.';
          } else {
            userMessage = err.message;
          }
          
          setError(userMessage);
        });
    } else {
      navigate('/');
    }
  }, [navigate]);

  if (error) {
    return (
      <>
        <Header />
        <div className="container mt-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Access Denied</h4>
            <p>{error}</p>
            <hr />
            <p className="mb-0">
              Please contact your administrator to be added to the Chat group.
            </p>
            <button className="btn btn-primary mt-3" onClick={() => navigate('/')}>
              Back to Login
            </button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="container text-center mt-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Authenticating...</p>
      </div>
    </>
  );
}

export default Callback;
